<template>
  <div>
    <!-- 아웃링크 -->
    <a v-if="linkTarget.type === 'outlink'"
      :href="setLink.href"
      :target="setLink.target"
      @click="onClick"
      class="moduleLink">
      {{text}}
    </a>
    <!-- 페이지 _self -->
    <router-link v-if="linkTarget.type === 'page' && setLink.target === '_self'"
      :to="linkTarget.pageId !== 'main'
      ? {
        name: 'page',
        params: {
          id: linkTarget.pageId,
          ln: ln
        }
      } : {
        name: 'main'
      }"
      @click.native="onClick"
      class="moduleLink">
      {{text}}
    </router-link>
    <!-- 페이지 _blank -->
    <a v-if="linkTarget.type === 'page' && setLink.target === '_blank'"
      :href="setLink.href"
      @click="onClick"
      target="_blank" class="moduleLink">
      {{text}}
    </a>
    <!-- 상품 -->
    <router-link v-if="linkTarget.type === 'product'"
      :to="{
        name: linkTarget.productCategory ? 'productCategory' : 'product',
        params: {
          productId: linkTarget.productId,
          ...linkTarget.productCategory && {
            category: linkTarget.productCategory
          },
          ln: ln
        }
      }"
      @click.native="onClick"
      class="moduleLink">
      {{text}}
    </router-link>
    <!-- 예약 -->
    <router-link v-if="linkTarget.type === 'reservation'"
      :to="{
        name: 'reservation',
        params: {
          reservationId: linkTarget.reservationId,
          ln: ln
        }
      }"
      @click.native="onClick"
      class="moduleLink">
      {{text}}
    </router-link>
    <!-- 바로가기 _self -->
    <a v-if="linkTarget.type === 'shortcut' && linkTarget.shortcutId === 'talk'"
      href="#"
      class="moduleLink talkLink"
      @click="talkOn">
      <span class="talkText">{{text}}</span>
      <span v-if="receivedTalk > 0" class="talkCnt notranslate" :style="{ ...skinStyle('countBg', 'background-color'), ...skinStyle('countText', 'color') }">{{receivedTalk}}</span>
    </a>
    <router-link v-if="linkTarget.type === 'shortcut' && linkTarget.shortcutId !== 'talk' && setLink.target === '_self'"
      :to="{
        name: shortcutName(linkTarget),
        params: shortcutParams(linkTarget)
       }"
      :target="setLink.target"
      @click.native="onClick"
      class="moduleLink">
      {{text}}
    </router-link>
    <!-- 바로가기 _blank -->
    <a v-if="linkTarget.type === 'shortcut' && setLink.target === '_blank'"
      :href="setLink.href"
      target="_blank"
      @click="onClick"
      class="moduleLink">
      {{text}}
    </a>
    <!-- 기능 -->
    <div v-if="linkTarget.type === 'func'"
      class="moduleLink"
      @click="setFunc">
      {{text}}
      <!-- 기능-객실제어 상태 토스트 메시지 -->
      <div v-if="func.control.statusMessage" class="msgToast notranslate" :class="{success: func.control.success}">
        <p v-html="func.control.statusMessage"></p>
      </div>
    </div>
    <a v-if="linkTarget.type === 'shortcut' && setLink.target === '_blank'"
      :href="setLink.href"
      target="_blank"
      @click="onClick"
      class="moduleLink">
      {{text}}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment/moment'

export default {
  props: [
    'lang',
    'linkTarget',
    'linkText'
  ],
  computed: {
    ...mapGetters({
      link: 'util/setLink',
      pointColors: 'common/getPointColors'
    }),
    locale () {
      return this.$store.state.system.locale.data
    },
    ln () {
      return this.$route.params.ln
    },
    siteInfo () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    setLink () {
      return this.link(this.linkTarget)
    },
    text () {
      if (!!this.linkText && !!this.lang) {
        return this.linkText[this.lang]
      } else {
        return ''
      }
    },
    receivedTalk () {
      const isTalk = this.$store.state.talkOn
      const count = !isTalk && this.$store.state.talk.received
      return count >= 100 ? '99+' : count
    }
  },
  data () {
    return {
      func: {
        control: {
          statusMessage: null,
          current: '',
          success: false
        }
      }
    }
  },
  methods: {
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    setSiteToSite () {
      const currentHost = window.location.host
      const currentSiteid = this.siteInfo && this.siteInfo.site
      const nextHost = this.setLink && this.setLink.linkInfo && this.setLink.linkInfo.host
      const nextSiteid = this.setLink && this.setLink.linkInfo && this.setLink.linkInfo.params.site
      /**
       * 뷰어 내 사이트간 이동시
       * 이전 사이트 정보를 로컬스토리지에 저장하여
       * 이동한 사이트에서 이전 사이트로 다시 접근할 수 있도록 함
       */
      if (currentHost === nextHost && currentSiteid !== nextSiteid) {
        localStorage.setItem('prevSiteUrl', window.location.href)
      }
    },
    onClick (e) {
      const pageonly = this.linkTarget.frame_false
      const params = getUrlParams()
      const updateParams = function () {
        return Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
      }
      function getUrlParams () {
        const params = {}
        window.location.search.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
          params[key] = value
        })
        return params
      }
      if (pageonly) {
        params.frame = false
      } else {
        delete params.frame
      }
      this.setSiteToSite()
      window.location.search = updateParams()
      if (this.setLink.href === '#') {
        e.preventDefault()
      }
    },
    setRcu (data) {
      this.func.control.current = data.item
      this.$store.commit('loading', true)
      this.$store.dispatch('control/setRoomControl', data).then((res) => {
        if (!res) {
          this.setStatusMessage('fail')
          this.$store.commit('loading', false)
        } else if (res.data.errorMessage && res.data.errorMessage.includes('deviceagent')) {
          this.setStatusMessage('noStatus')
          this.$store.commit('loading', false)
        }
        setTimeout(() => {
          this.$store.commit('loading', false)
          if (res.data.message && res.data.message.toLowerCase() === 'ok') {
            this.func.control.success = true
            if (this.func.control.current === 'door') {
              this.setStatusMessage('doorOk')
            }
          }
          this.func.control.current = ''
        }, 3000)
      })
    },
    setStatusMessage (status) {
      if (status === 'noStatus') {
        // 등록된 제어모듈 정보가 없습니다. 객실제어가 올바르게 작동하지 않을 수 있습니다.
        this.func.control.statusMessage = `${this.locale.message_roomcontrol_nostatus}<br>${this.locale.message_roomcontrol_malfunction}`
      } else if (status === 'fail') {
        // 연결상태가 원활하지 않습니다.
        this.func.control.statusMessage = this.locale.message_connection
      } else if (status === 'close') {
        // 현재상태를 불러올 수 없습니다.
        this.func.control.statusMessage = this.locale.message_roomcontrol_close
      } else if (status === 'doorOk') {
        // 문이 열립니다.
        this.func.control.statusMessage = this.locale.message_door_open
      }
      setTimeout(() => {
        this.func.control.statusMessage = null
      }, 5000)
    },
    setFunc () {
      const func = this.setLink.href
      if (func === 'roomkey') {
        const data = {
          item: 'door',
          param1: '0',
          param2: 'on'
        }
        this.setRcu(data)
      } else if (func === 'eventTrigger') {
        this.evtTrigger(this.linkTarget.eventTriggerFunc)
      }
    },
    shortcutName (target) {
      let name = target.shortcutId.split('/')[0]
      if (target.shortcutId === 'localinfo' && !!target.localinfotype) {
        name = 'filteredLocalinfo'
      }
      return name
    },
    shortcutParams (target) {
      const params = {}
      params.lang = this.lang || this.ln
      if (target.shortcutId === 'localinfo' && !!target.localinfotype) {
        params.type = target.localinfotype
      }
      if (target.shortcutId.split('/')[0] === 'waitingcall') {
        params.nationality = target.shortcutId.split('/')[1] || 'domestic'
      }
      return params
    },
    talkOn () {
      this.$store.commit('talk', true)
    },
    evtTrigger (triggerFunc) {
      const lang = this.ln
      const setVars = (str) => {
        // 변수처리 case
        const pattern = /(?=\{)(.*?)(?=\})/g
        const split = str.split(pattern)
        let result = []
        split.forEach(function (itemStr) {
          itemStr = itemStr.replace(/{|}/g, '')
          switch (itemStr) {
            case 'lang':
              result.push(lang)
              break
            default:
              result.push(itemStr)
          }
        })
        return result.join('')
      }
      /**
       * (커스텀 / aka.신라F&B)
       * 뷰어 내에서 사이트간 이동시
       * A -> B 사이트 이동시
       * 직전 사이트 A의 메인으로 돌아가는 링크 생성
       */
      if (triggerFunc && triggerFunc === 'prevSite') {
        const prevSite = localStorage.getItem('prevSiteUrl')
        if (prevSite) {
          window.location.href = prevSite
        }
      } else if (triggerFunc) {
        /**
         * 체크인 이벤트 등 서버로 요청하기 위한 이벤트 트리거
         * 워커힐 피자힐(fbpiz)에서
         * 새로운 체크인 처리를 위한 용도로 추가
         */
        const split = triggerFunc.split((/_|\?/))
        const returnUrlKey = split.find(x => x.includes('link')) || 'publiclink' // 리턴url을 public형태로 받을지 ota형태로 받을지
        const queryString = split.find(x => x.includes('#')) ? setVars(split.find(x => x.includes('#'))) : '' // 리턴url로 붙을 파라미터를 포함한 path (없으면 메인)
        this.$store.commit('loading', true)
        if (queryString) {
          triggerFunc = `${triggerFunc.split('?')[0]}?${queryString}`
        }
        this.$store.dispatch('util/eventTrigger', {
          func: triggerFunc
        }).then((res) => {
          const returnUrl = res && res[returnUrlKey]
          if (returnUrl) {
            window.location.href = returnUrl
          } else {
            if (res && res.message) {
              alert(res.message)
            }
            this.$store.commit('loading', false)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.msgToast {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 300px;
  padding: 0.5em 1em;
  text-align: center;
  color: $color-white;
  word-break: break-all;
  border-radius: 4px;
  background-color: rgba($color-red, 0.85);
  transform: translate(-50%, -50%);
  &.success {
    background-color: rgba($color-green, 0.85);
  }
}
</style>
